import { render } from "./HeroiconsSolidPhoneMissedCall.vue?vue&type=template&id=6b904d2b"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneMissedCall.vue"]])

export default __exports__